import { render } from "./TemplateList.vue?vue&type=template&id=b6dd58b8&scoped=true&ts=true"
import script from "./TemplateList.vue?vue&type=script&lang=ts"
export * from "./TemplateList.vue?vue&type=script&lang=ts"

import "./TemplateList.vue?vue&type=style&index=0&id=b6dd58b8&lang=scss&scoped=true"

import exportComponent from "/root/workspace/lll-ui_hccl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6dd58b8"]])

export default __exports__